export enum StorageKeys {
  bearerToken = "bearerToken",
  expireDate = "expireDate",
  userName = "userName",
  merchantId = "merchantId",
  merchantName = "merchantName",
  systemPassword = "systemPassword",
  order = "userOrder",
  level = "userLevel",
  userId = "userId",
  isPayoutBlocked = "isPayoutBlocked",
  payoutBlockReason = "payoutBlockReason",
  level = "userLevel",
  userId = "userId",
  userType = "userType"
}
